import { __read } from 'tslib';
import React, { useState, useRef, useEffect } from 'react';
import { ArrowIcon2 } from '../../../../components/ArrowIcon/index.js';
import cx from 'classnames';

var Nav = function Nav(props) {
  var menus = props.menus,
    className = props.className;
  var _a = __read(useState(0), 2),
    scrollPosition = _a[0],
    setScrollPosition = _a[1];
  var scrollWrapperRef = useRef(null);
  var _b = __read(useState(0), 2),
    contentWidth = _b[0],
    setContentWidth = _b[1];
  var _c = __read(useState(0), 2),
    viewportWidth = _c[0],
    setViewportWidth = _c[1];
  useEffect(function () {
    // 初始化宽度
    updateWidths();
    window.addEventListener('resize', updateWidths);
    return function () {
      window.removeEventListener('resize', updateWidths);
    };
  }, []);
  useEffect(function () {
    // 当窗口或内容宽度变化时，重新计算滚动位置
    var maxScrollPosition = viewportWidth - contentWidth;
    setScrollPosition(function (scrollPosition) {
      return Math.max(scrollPosition, maxScrollPosition);
    });
  }, [contentWidth, viewportWidth]);
  // 更新滚动区域宽度
  var updateWidths = function updateWidths() {
    var scrollWrapperDom = scrollWrapperRef.current;
    if (!scrollWrapperDom) return;
    var scrollWidth = scrollWrapperDom.scrollWidth,
      offsetWidth = scrollWrapperDom.offsetWidth;
    setContentWidth(scrollWidth);
    setViewportWidth(offsetWidth);
  };
  var canScrollLeft = scrollPosition < 0;
  var canScrollRight = Math.abs(scrollPosition) < contentWidth - viewportWidth;
  var handleScrollClick = function handleScrollClick(direction) {
    var scrollWrapperDom = scrollWrapperRef.current;
    if (!scrollWrapperDom) return;
    var contentWidth = scrollWrapperDom.scrollWidth,
      viewportWidth = scrollWrapperDom.offsetWidth;
    var newScrollPosition = scrollPosition + direction * viewportWidth;
    // 限制滚动范围
    var maxScrollPosition = 0;
    var minScrollPosition = viewportWidth - contentWidth;
    var boundedScrollPosition = Math.min(maxScrollPosition, Math.max(minScrollPosition, newScrollPosition));
    setScrollPosition(boundedScrollPosition);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('header-nav-wrapper', className, {
      'nav-btn-show--left': canScrollLeft,
      'nav-btn-show--right': canScrollRight
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('nav-btn-wrapper nav-btn-wrapper-left', {
      'nav-btn-show': !canScrollLeft
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-btn nav-btn-left",
    onClick: function onClick() {
      return handleScrollClick(1);
    }
  }, /*#__PURE__*/React.createElement(ArrowIcon2, null))), /*#__PURE__*/React.createElement("div", {
    className: "header-nav nav-scroll",
    ref: scrollWrapperRef
  }, /*#__PURE__*/React.createElement("ul", {
    className: "header-nav-list",
    style: {
      transform: "translateX(".concat(scrollPosition, "px)")
    }
  }, menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
    var _a, _b, _c, _d, _e, _f;
    var title = item.title,
      link = item.link,
      _g = item.target,
      target = _g === void 0 ? '_blank' : _g;
    return /*#__PURE__*/React.createElement("li", {
      className: "header-link",
      key: title + index
    }, /*#__PURE__*/React.createElement("a", {
      href: link,
      target: target,
      rel: "noopener noreferrer",
      "data-track-name": (_b = (_a = item.trackInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '文字链',
      "data-track-value": (_d = (_c = item.trackInfo) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : title,
      "data-track-category": (_f = (_e = item.trackInfo) === null || _e === void 0 ? void 0 : _e.category) !== null && _f !== void 0 ? _f : '头部导航'
    }, title));
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('nav-btn-wrapper nav-btn-wrapper-right', {
      'nav-btn-show': !canScrollRight
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-btn nav-btn-right",
    onClick: function onClick() {
      return handleScrollClick(-1);
    }
  }, /*#__PURE__*/React.createElement(ArrowIcon2, null))));
};

export { Nav as default };
